<template>
    <b-row>
        <b-col cols="12">
            <b-card title="">
                <b-overlay
                    variant="white"
                    :show="showLoading"
                    spinner-variant="primary"
                    blur="0"
                    opacity=".75"
                    rounded="sm"
                >
                    <div class="ml-1 mb-2">
                        <b-row>
                            <b-col cols="12" class="d-flex align-items-center mb-1 mb-md-0">
                                <b-button variant="primary" @click="goToCreate()">
                                    Crear usuario
                                </b-button>
                            </b-col>
                        </b-row>
                    </div>

                    <b-table
                        ref="refUserListTable"
                        class="position-relative"
                        :items="users"
                        responsive
                        :fields="columns"
                        primary-key="id"
                        show-empty
                        empty-text="No hay registros"
                    >
                        <template #cell(name)="data">
                            <router-link :to="{ name: 'users_edit', params: { id: data.item.id} }">
                                {{ data.item.name }}
                            </router-link>
                        </template>

                        <template #cell(created_at)="data">
                            {{ formatDate(data.item.created_at) }}
                        </template>

                        <template #cell(roles)="data">
                            <b-badge v-for="role in data.item.roles" :key="role.id" class="mr-1" :class="role.name === 'Lectura/Escritura GEI' ? 'bg-primary' : ''"
                                     :variant="role.name === 'Lectura/Escritura GEI' ? 'white' : 'light-primary'">
                                {{ role.name }}
                            </b-badge>
                        </template>

                        <template #cell(companies)="data">
                            <b-badge v-for="company in data.item.companies" :key="company.id" class="mr-1"
                                     variant="secondary">
                                {{ company.name }}
                            </b-badge>
                        </template>

                        <template #cell(permissions)="data">
                            <b-badge

                                v-for="permission in data.item.permissions.filter(permission => permissions.some(filled => filled.id === permission.id))"
                                :key="permission.id"
                                class="mr-1"
                                variant="secondary"
                            >
                                {{ permission.display_name }}
                            </b-badge>
                        </template>


                        <template #cell(actions)="data">
                            <div class="m-1 no-wrap">
                                <router-link :to="{ name: 'users_edit', params: { id: data.item.id} }">
                                    <feather-icon
                                        v-if="can('list_users')"
                                        :id="`invoice-row-${data.item.id}-send-icon`"
                                        icon="EditIcon"
                                        class="cursor-pointer"
                                        size="16"
                                    />
                                    <b-tooltip
                                        title="Editar Usuario"
                                        class="cursor-pointer"
                                        :target="`invoice-row-${data.item.id}-send-icon`"
                                    />
                                </router-link>

                                <feather-icon
                                    v-if="can('list_users')"
                                    :id="`invoice-row-${data.item.id}-preview-icon`"
                                    icon="TrashIcon"
                                    size="16"
                                    class="cursor-pointer mx-1 text-red"
                                    @click="deleteUser(data.item.id)"
                                />
                                <b-tooltip
                                    title="Eliminar Usuario"
                                    :target="`invoice-row-${data.item.id}-preview-icon`"
                                />
                            </div>
                        </template>
                    </b-table>
                </b-overlay>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import {BRow, BCol, BTable, BCard, BBadge, BButton, BTooltip, BOverlay} from 'bootstrap-vue'
import {mapState} from "vuex"
import Swal from "sweetalert2"
import {USER_CREATE} from "@/router/web/constants"
import {fillablePermissions, fillablePermissionsVHE} from "@/constants/permissions"
import authService from "@/services/auth/authService"

export default {
    name: "ListView",
    components: {
        BRow,
        BCol,
        BTable,
        BCard,
        BBadge,
        BButton,
        BTooltip,
        BOverlay,
    },
    data() {
        return {
            showLoading: false,

            columns: [
                {key: 'actions', label: 'Acciones', sortable: false, tdClass: 'no-wrap'},
                {key: 'name', label: 'Nombre', sortable: false},
                {key: 'roles', label: 'Permisos', sortable: false},
                {key: 'email', label: 'Email', sortable: false},
                {key: 'created_at', label: 'Fecha de creación', sortable: false},
                {key: 'companies', label: 'Empresa', sortable: false},
                {key: 'permissions', label: 'Visualización', sortable: false},
            ],
        }
    },
    computed: {
        platform() {
            return authService.activePlatform()
        },
        permissions() {
            if (authService.activePlatform()=='VHE')
                return fillablePermissionsVHE
            else
                return fillablePermissions
        },
        ...mapState('user', ['users']),
    },
    created() {
        this.getUsers()
    },
    methods: {

        can(permission) {
            return this.$store.getters.can(permission)
        },
        formatDate(date) {
            const dateFormated = new Date(date)

            return dateFormated.toLocaleDateString("es-ES")
        },
        getUsers() {
            this.showLoading = true

            this.$store.dispatch('user/listAllUsers', {
                relations: ['roles', 'companies', 'permissions'],
            })
                .then(response => {
                    this.showLoading = false
                })
                .catch(error => {
                    this.showLoading = false
                    console.log(error)
                })
        },
        deleteUser(id) {
            Swal.fire({
                title: "¿Está seguro?",
                text: "Recuerda que una vez borrado, no podrá recuperar el usuario",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#ff0000",
                cancelButtonColor: "#a1a1a1",
                confirmButtonText: "¡Sí, quiero borrar este usuario!",
                cancelButtonText: "Cancelar",
            }).then(result => {
                if (result.value) {
                    this.$store.dispatch('user/deleteUser', {id: id})
                        .then(response => {
                            this.showLoading = false
                            this.getUsers()
                        })
                        .catch(error => {
                            this.showLoading = false
                            console.log(error)
                        })
                }
            })
        },
        changePage(page) {
            this.page = page
            this.getUsers()
        },
        changeLength(length) {
            this.length = length
            this.getUsers()
        },
        goToCreate() {
            this.$router.push(USER_CREATE)
        },
        fillablePermissions() {
          return fillablePermissions
        }
    }
}
</script>

<style lang="scss">
.no-wrap {
    white-space: nowrap;
}

@import '@core/scss/vue/libs/vue-select.scss';
</style>